const PhoneRegex = /^01[0125][0-9]{8}$/gm
const EmailRegex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/gm
const PhoneOrEmailRegex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$|^01[0125][0-9]{8}$/gm

export { PhoneRegex, EmailRegex, PhoneOrEmailRegex }
